import copy from 'clipboard-copy'
import { mapGetters, mapState } from 'vuex'

export default
{
	computed:
	{
		...mapState
		({
			user: state => state.authUser,
		}),

		...mapGetters
		([
			'fullName',
			'userInitials',
		]),

		isAuthenticated()
		{
			return this.user?.authenticated === true
		},

		isUserRegistered()
		{
			return this.isAuthenticated && this.user?.is_registered === true
		},

		isEDI()
		{
			return this.isAuthenticated && this.user?.is_edi === true
		},

		userIsAdminOrBilling()
		{
			const { is_admin, is_billing } = this.user ?? {}

			return is_admin || is_billing
		},

		userIsAdminOrPrimary()
		{
			const { is_admin, is_primary } = this.user ?? {}

			return is_admin || is_primary
		},

		userIsAdminOrPrimaryTech()
		{
			const { is_admin, is_primary, is_tech } = this.user ?? {}

			return is_admin || is_primary || is_tech
		}
	},

	methods:
	{
		copyEmail(e)
		{
			e.preventDefault()

			copy(this.user.email).then(() => this.sendNotification('Email address copied to clipboard'))
		},
	},
}